import QRCodeStyling from 'qr-code-styling';

export function createQr(container, url, logo) {

    if (!container || !url) {
        return;
    }

    container.innerHTML = '';

    const qrCode = new QRCodeStyling({

        width: 240,

        height: 240,

        type: 'svg',

        data: url,

        image: logo,

        margin: 0,

        dotsOptions: {
            color: '#3a3087',
            type: 'rounded'
        },

        backgroundOptions: {
            color: '#FFFFFF'
        },

        cornersSquareOptions: {
            color: '#3a3087',
            type: 'extra-rounded'
        },

        cornersDotOptions: {
            color: '#3a3087',
            type: 'dot'
        },

        imageOptions: {

            margin: 6,

            imageSize: 0.28,

            hideBackgroundDots: true
        },

        qrOptions: {
            errorCorrectionLevel: 'H'
        }
    });

    qrCode.append(container);
}
